import { useState, useEffect, useMemo } from 'react';

import dayjs from 'dayjs';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import attendanceSettlementService from '../../service/attendanceSettlement/attendanceSettlement.service';
import { Box, Button } from '@mui/material';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';

const AttendanceSettlementReports = ({ values, autocompleteOptions, refetch }) => {
  const { setSelectedValues, selectedValues } = values;
  const { refetchTable, setRefetchTable } = refetch;
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'createdAt', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getList = (gridState) => {
    attendanceSettlementService.getData(gridState).then((data) => {
      setReports(data);
    });
  };

  const handleExport = () => {
    attendanceSettlementService.getExcelData(selectedValues.id).then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'id',
        headerName: 'Azonosító',
        type: 'number',
        filterable: false,
      },
      {
        field: 'createdAt',
        headerName: 'Dátum',
        type: 'date',
        valueGetter: (_data, row) => {
          return new Date(row.createdAt);
        },
        renderCell: (data) => {
          return dayjs(data.row.createdAt).format('YYYY.MM.DD');
        },
      },
      {
        field: 'projectId',
        headerName: 'Projekt',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return data.row.project?.projectName;
        },
      },
      {
        field: 'companyId',
        headerName: 'Cég',
        type: 'singleSelect',
        sortable: false,
        renderCell: (params) => {
          return params.row.company?.name;
        },
        valueOptions: autocompleteOptions.company,
      },
    ]);
  }, [autocompleteOptions]);

  return (
    <>
      {Object.keys(autocompleteOptions).length > 0 && (
        <DatagridPremiumUi
          datagridIdentifier={DataGridIdentifiers.AttendanceSettlement}
          datagridInitialState={initialState}
          dataLoader={getList}
          rows={reports.rows}
          refetch={{ refetchTable, setRefetchTable }}
          rowCount={reports.rowCount}
          columns={[...columns]}
          onRowClick={(rowData) => {
            setSelectedValues(rowData.row);
          }}
          paginationAndfilterMode="server"
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          customHeaderComponent={
            <Box ml="auto">
              <Button
                variant="text"
                size="small"
                color="primary"
                disableElevation
                disabled={!selectedValues.id}
                onClick={handleExport}
              >
                Exportálás
              </Button>
            </Box>
          }
          rowSelectionModel={rowSelectionModel}
        />
      )}
    </>
  );
};

export default AttendanceSettlementReports;
